import ContainerHome24 from '@/components/atoms/ContainerHome24';
import React, { useState } from 'react';
import Styles from './CanaisAtendimentoTelefone.css';

function CanaisAtendimentoTelefone({ show }) {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <section id="canais-atendimento-telefones" className={show ? 'show' : ''}>
      <ContainerHome24>
        <div className="telefones-canais">
          <div className="telefones-content">
            <div className="telefone-bloco">
              <h3 className="telefones-title">Central de atendimento</h3>
              <p className="telefones-paragrafo">
                Financiamento de veículos, bens e serviços. Consultas, informações, transações e
                cancelamentos
                <br />
                <br className="only-mobi" />
                De segunda a sexta-feira, das 8h às 20h e aos sábados, das 08 às 14h, exceto
                feriado.
              </p>
              <div className="telefone-numero">
                <a href="tel:4004 9090" id="tel-4004-9090">
                  4004 9090
                </a>
                <p className="tel-parenteses">(regiões metropolitanas)</p>
              </div>
              <div className="telefone-numero">
                <a href="tel:0800 722 9090" id="tel-0800-722-9090">
                  0800 722 9090
                </a>
                <p className="tel-parenteses">(demais localidades)</p>
              </div>
            </div>

            <div className="telefone-bloco">
              <h3 className="telefones-title">SAC</h3>
              <p className="telefones-paragrafo">Todos os dias, 24h por dia.</p>
              <div className="telefone-numero">
                <a href="tel:0800 762 7777" id="tel-0800-762-7777">
                  0800 762 7777
                </a>
                <p className="tel-parenteses">(capitais e regiões metropolitanas)</p>
              </div>
              <div className="telefone-numero">
                <a href="tel:+55 (11) 3012-3336" id="tel-+55-(11)-3012-3336">
                  +55 (11) 3012-3336
                </a>
                <p className="tel-parenteses">(no exterior, ligue a cobrar)</p>
              </div>
              {/* <div className="telefone-numero link-sac">
                <a
                  href="https://octagora.com/s/StderLibrs"
                  id="sac-ouvidoria-libras"
                  target="_blank"
                >
                  Atendimento em Libras (Canal Exclusivo para Atendimento em Libras)
                </a>
                <p className="libras-disclaimer">
                  <i>Horário de atendimento de Seg a Sexta das 08:00 as 20:00, exceto feriados.</i>
                </p>
              </div> */}
            </div>

            <div className="telefone-bloco">
              <h3 className="telefones-title">Ouvidoria</h3>
              <p className="telefones-paragrafo">
                Se não ficar satisfeito com a solução apresentada.
                <br />
                <br className="only-mobi" />
                De segunda a sexta-feira, das 9h às 18h, exceto feriado.
              </p>
              <div className="telefone-numero">
                <a href="tel:0800 726 0322" id="tel-0800-726-0322">
                  0800 726 0322
                </a>
              </div>
              {/* <div className="telefone-numero">
                <a href="tel:0800 771 0301" id="tel-0800-771-0301">
                  0800 771 0301
                </a>
                <p className="tel-parenteses">(pessoas com deficiência auditiva e de fala)</p>
              </div> */}
              <div className="telefone-numero">
                <a href="tel:+55 (11) 3012 0322" id="tel-+55-(11)-3012-0322">
                  +55 (11) 3012 0322
                </a>
                <p className="tel-parenteses">(Ligações do exterior - a cobrar)</p>
              </div>
              <div className="telefone-numero link-sac">
                <a
                  href="https://octagora.com/s/StderLibrs"
                  id="sac-ouvidoria-libras"
                  target="_blank"
                >
                  SAC e Ouvidoria com Canal Exclusivo para Atendimento em Libras
                </a>
                <p className="libras-disclaimer">
                  <i>
                    Horário de atendimento de segunda a sexta-feira das 8h às 20h, exceto feriados.
                  </i>
                </p>
              </div>
            </div>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <img
                  src="assets/canais-de-atendimento/celular.svg"
                  alt="celular para WhatsApp Santander"
                  className="img-celular"
                />
              )}
              {width > 992 && (
                <img
                  src="assets/canais-de-atendimento/celular-desk.svg"
                  alt="celular para WhatsApp Santander"
                  className="img-celular"
                />
              )}
            </>
          )}
          {/* <img
            className="logo-santander"
            src="assets/canais-de-atendimento/santander-desktop.svg"
            alt="logo santander"
          /> */}
        </div>
        {/* <div className="telefones-fgts">
          <div className="telefones-content">
            <div className="telefone-bloco">
              <h3 className="telefones-title title-fgts">
                Contatos para clientes com empréstimos e antecipação do FGTS:
              </h3>
              <h3 className="telefones-title">Central de atendimento</h3>
              <p className="telefones-paragrafo">
                Atendimento é 100% online pelo WhatsApp
                <br />
                <br className="only-mobi" />
                De segunda a sexta-feira, das 7h às 19h Sábado das 08h ás 14h, exceto feriados.
              </p>
              <div className="telefone-numero">
                <a
                  href="https://api.whatsapp.com/send?phone=551130034362&text=Oi"
                  target="_blank"
                  id="tel-(11)-3003-4362"
                >
                  (11) 3003-4362
                </a>
              </div>
            </div>

            <div className="telefone-bloco">
              <h3 className="telefones-title">Central de Negociação e Seguros</h3>
              <p className="telefones-paragrafo">
                De segunda a sexta das 8h às 21h e aos sábado das 09h às 14h20, exceto feriados.
              </p>
              <div className="telefone-numero">
                <a href="tel:3003-4362" id="tel-3003-4362">
                  3003-4362
                </a>
              </div>
              <div className="telefone-numero">
                <a href="tel:0800 720 4362" id="tel-0800-720-4362">
                  0800 720 4362
                </a>
                <p className="tel-parenteses">(regiões metropolitanas)</p>
              </div>
            </div>

            <div className="telefone-bloco">
              <h3 className="telefones-title">SAC</h3>
              <p className="telefones-paragrafo">
                Reclamações, cancelamentos e informações. Todos os dias da semana 24h.
              </p>
              <div className="telefone-numero">
                <a href="tel:0800 720 4367" id="tel-0800-720-4367">
                  0800 720 4367
                </a>
              </div>
              <div className="telefone-numero">
                <a href="tel:0800 720 4368" id="tel-0800-720-4368">
                  0800 720 4368
                </a>
                <p className="tel-parenteses">(pessoas com deficiência auditiva e de fala)</p>
              </div>
            </div>

            <div className="telefone-bloco">
              <h3 className="telefones-title">Ouvidoria</h3>
              <p className="telefones-paragrafo">
                Se não ficar satisfeito com a solução apresentada.
                <br />
                <br className="only-mobi" />
                De segunda a sexta-feira, das 09h às 18h, exceto feriados.
              </p>
              <div className="telefone-numero">
                <a href="tel:0800 720 4365" id="tel-0800-720-4365">
                  0800 720 4365
                </a>
              </div>
              <div className="telefone-numero">
                <a href="tel:0800 720 4366" id="tel-0800-720-4366">
                  0800 720 4366
                </a>
                <p className="tel-parenteses">(pessoas com deficiência auditiva e de fala)</p>
              </div>
            </div>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <img
                  src="assets/canais-de-atendimento/celular.svg"
                  alt="celular para WhatsApp Santander"
                  className="img-celular"
                />
              )}
            </>
          )}
        </div> */}
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default CanaisAtendimentoTelefone;
